import { render, staticRenderFns } from "./ModalAdminAddtional.vue?vue&type=template&id=2ee4f0b6"
import script from "./ModalAdminAddtional.vue?vue&type=script&lang=js"
export * from "./ModalAdminAddtional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports